// extracted by mini-css-extract-plugin
module.exports = {"list":"MenuList_list__384uR","item":"MenuList_item__2_wAZ","scrollable":"MenuList_scrollable__34Eqj"};